import makeApi from '../client/api'

export const getPropertyAnnouncement = async (announcementId, token) => {
  const api = makeApi({ token })

  return api.getOne('/announcements/properties', { id: announcementId })
}

export const getUserAnnouncements = async (userId, token, offset) => {
  const api = makeApi({ token })

  const options = {
    filter: {
      user_id: userId,
      is_rented: false,
      $limit: 10,
      $skip: offset || 0,
    },
  }

  const response = await api.getList('/announcements/properties', options)

  return response
}

export const createNewPropertyAnnouncement = async (userId, token, propertyAnnouncement) => {
  const api = makeApi({ token })

  const response = await api.create('/announcements/properties', {
    data: { user_id: userId, ...propertyAnnouncement },
  })
  return response
}

export const updateAnnouncement = async (token, announcementId, newPayload) => {
  const api = makeApi({ token })

  return api.update('/announcements/properties/', {
    id: announcementId,
    data: { ...newPayload },
  })
}
